import React, { useState, useEffect } from 'react';
import { parseBangkokInstant } from '../contexts/constants';

const countdownConfig = {
  powerball: {
    title: 'Powerball',
    color: '#e92838',
    textColor: '#ffffff',
    imageSrc: '/pawerball-icon.png'
  },
  megamillions: {
    title: 'Mega Millions',
    color: '#ffd100',
    textColor: '#000000',
    imageSrc: '/megamillion-icon.png'
  }
};

const Countdown = ({ targetDate, orderActive, orderStatus, type = 'powerball', orientation = 'horizontal' }) => {
  const [currentTime, setCurrentTime] = useState(new Date());

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentTime(new Date());
    }, 1000);
    return () => clearInterval(timer);
  }, []);

    if (Number(orderStatus) === 1) {
		return (
			<div className="text-center p-4 bg-gray-100 dark:bg-gray-800 rounded-lg">
				<p className="font-semibold text-gray-700 dark:text-gray-300">สรุปผลแล้ว</p>
			</div>
		);
	}

    if (Number(orderActive) === 0) {
		return (
			<div className="text-center p-4 bg-gray-100 dark:bg-gray-800 rounded-lg">
				<p className="font-semibold text-gray-700 dark:text-gray-300">การสั่งซื้อถูกปิดอยู่</p>
			</div>
		);
	}

  const calculateTimeLeft = () => {
    const targetInstant = parseBangkokInstant(targetDate);
    if (!targetInstant || isNaN(targetInstant.getTime())) {
      return { days: 0, hours: 0, minutes: 0, seconds: 0, expired: true };
    }
    const difference = targetInstant - currentTime;

    if (difference <= 0) {
      return { days: 0, hours: 0, minutes: 0, seconds: 0, expired: true };
    }

    return {
      days: Math.floor(difference / (1000 * 60 * 60 * 24)),
      hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
      minutes: Math.floor((difference / 1000 / 60) % 60),
      seconds: Math.floor((difference / 1000) % 60),
      expired: false
    };
  };

  const timeLeft = calculateTimeLeft();
  const config = countdownConfig[type] || countdownConfig.powerball;

  if (timeLeft.expired) {
    return (
      <div className="text-center p-4 bg-gray-100 dark:bg-gray-800 rounded-lg">
        <p className="font-semibold text-gray-700 dark:text-gray-300">การนับถอยหลังสิ้นสุดแล้ว</p>
      </div>
    );
  }

  const timeUnits = [
    { label: 'วัน', value: timeLeft.days },
    { label: 'ชั่วโมง', value: String(timeLeft.hours).padStart(2, '0') },
    { label: 'นาที', value: String(timeLeft.minutes).padStart(2, '0') },
    { label: 'วินาที', value: String(timeLeft.seconds).padStart(2, '0') },
  ];

  const isHorizontal = orientation === 'horizontal';

  return (
    <div
      className={`relative p-4 max-w-[90%] sm:mx-auto`}
      // style={{ backgroundColor: config.color }}
    >
      <div className={`grid ${isHorizontal ? 'grid-cols-4' : 'grid-cols-2'} gap-3 text-center`}>
        {timeUnits.map(unit => (
          <div key={unit.label} className="backdrop-blur-sm rounded-lg p-2" style={{ backgroundColor: config.color }}>
            <div className="text-2xl font-bold" style={{ color: config.textColor }}>{unit.value}</div>
            <div className="text-xs opacity-90" style={{ color: config.textColor }}>{unit.label}</div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Countdown;
